import LearningResultBarCharts from './LearningResultBarCharts';

export default LearningResultBarCharts;
